import { defineMessages } from 'react-intl'

import { IN_STOCK } from './constants'

export const inStockMessages = defineMessages({
  [IN_STOCK.WITH_PRODUCTS]: {
    id: 'spanish.items.filter.inStock.withProducts',
    defaultMessage: 'Productos con stock'
  },
  [IN_STOCK.WITHOUT_PRODUCTS]: {
    id: 'spanish.items.filter.inStock.withoutProducts',
    defaultMessage: 'Productos sin stock'
  },
  [IN_STOCK.ALL]: {
    id: 'spanish.items.filter.inStock.withAndWithoutProducts',
    defaultMessage: 'Todo'
  }
})
